import React from 'react'
import {useTranslation} from 'next-i18next'

const Field = ({label, key, value}) => {
  const {t} = useTranslation('generic')
  let finalValue = typeof value === 'string' ? value : value ? t('yes') : t('no')
  finalValue = finalValue.length > 20 ? `${finalValue.substring(0, 20)}...` : finalValue
  return (
    <li className="list-none" key={key}>
      {label}: {finalValue}
    </li>
  )
}

export default function FormStateSummary({orderParamsSchema, preferences}) {
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'customFields'})
  if (!preferences?.orderParams) return null
  const selections = Object.keys(preferences.orderParams).filter(
    key => preferences.orderParams[key] && preferences.orderParams[key] !== ''
  )

  return (
    <div className="text-gray-400">
      {selections.slice(0, 2).map((key: any, index) =>
        index === 0 ? (
          <Field
            key={key}
            label={orderParamsSchema[key]?.label}
            value={preferences.orderParams[key]}
          />
        ) : (
          <p key={key} className="text-sm">
            {t('otherIndications', {amount: selections.length - 1})}
          </p>
        )
      )}
    </div>
  )
}
